import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestTypes, requestParams } from './approvals_group_reducer';

const useSelectUserModal = (
  admins,
  approvers,
  users,
  adminsCount,
  approversCount,
  usersCount,
  adminsSelectionCount,
  approversSelectionCount,
  usersSelectionCount,
  approvalsGroupText,
  request,
  getUsersUrl,
  approvalGroupDispatch,
  groupActions,
) => {
  const {
    admins: adminsText,
    approvers: approversText,
    users: usersText,
  } = approvalsGroupText;

  const createModalOptions = (
    role,
    usersList,
    userCount,
    modalSelectionCount,
    action,
  ) => ({
    showModal: true,
    title: approvalsGroupText[role].title,
    cta: approvalsGroupText[role].cta,
    users: JSON.parse(JSON.stringify(usersList)),
    userCount,
    modalSelectionCount,
    currentSelectionCount: modalSelectionCount,
    selectAllUsers: userCount === modalSelectionCount,
    orderByName: false,
    orderByLimit: false,
    actionType: action,
  });

  const openUsersModal = userType => {
    switch (userType) {
      case adminsText.title: {
        const adminModalOptions = createModalOptions(
          'admins',
          admins,
          adminsCount,
          adminsSelectionCount,
          groupActions.UPDATE_ALL_ADMINS,
        );
        if (admins.length !== adminsCount) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: adminModalOptions,
          });
          approvalGroupDispatch({
            type: groupActions.ENABLE_REQUEST,
            payload: {
              type: requestTypes.USER_REQUEST,
              params: requestParams.ADMINS_ROLE,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: adminModalOptions,
          });
        }
        break;
      }
      case approversText.title: {
        const approverModalOptions = createModalOptions(
          'approvers',
          approvers,
          approversCount,
          approversSelectionCount,
          groupActions.UPDATE_ALL_APPROVERS,
        );
        if (approvers.length !== approversCount) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: approverModalOptions,
          });
          approvalGroupDispatch({
            type: groupActions.ENABLE_REQUEST,
            payload: {
              type: requestTypes.USER_REQUEST,
              params: requestParams.APPROVERS_ROLE,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: approverModalOptions,
          });
        }
        break;
      }
      case usersText.title: {
        const userModalOptions = createModalOptions(
          'users',
          users,
          usersCount + approversCount,
          usersSelectionCount,
          groupActions.UPDATE_ALL_USERS,
        );
        if (users.length !== usersCount) {
          approvalGroupDispatch({
            type: groupActions.UPDATE_USERS_REQUEST,
            payload: userModalOptions,
          });
          approvalGroupDispatch({
            type: groupActions.ENABLE_REQUEST,
            payload: {
              type: requestTypes.USER_REQUEST,
              params: requestParams.USERS_ROLE,
            },
          });
        } else {
          approvalGroupDispatch({
            type: groupActions.CREATE_USER_MODAL,
            payload: userModalOptions,
          });
        }
        break;
      }
      default:
    }
  };

  const closeUsersModal = () => {
    approvalGroupDispatch({ type: groupActions.RESET_USER_MODAL });
  };

  // ---- REQUEST USERS ---- //

  const submitUserRequest =
    request.status && request.type === requestTypes.USER_REQUEST;

  const { data: usersHttpData, error: usersHttpError } = useHTTP({
    url: submitUserRequest ? `${getUsersUrl}${request.params}` : null,
  });

  useEffect(() => {
    if (usersHttpError === undefined) return;
    approvalGroupDispatch({ type: groupActions.ERROR_USERS_REQUEST });
    approvalGroupDispatch({ type: groupActions.DISABLE_REQUEST });
  }, [usersHttpError]);

  useEffect(() => {
    if (usersHttpData === undefined) return;
    if (usersHttpData.approval_group_users) {
      approvalGroupDispatch({
        type: groupActions.ADD_USERS_REQUEST,
        payload: usersHttpData.approval_group_users,
      });
      approvalGroupDispatch({
        type: groupActions.DISABLE_REQUEST,
      });
      approvalGroupDispatch({ type: groupActions.DISABLE_REQUEST });
    }
  }, [usersHttpData]);

  return { openUsersModal, closeUsersModal };
};

export default useSelectUserModal;
